var loadReels;

$(function(){

  loadReels = {
    page : 1,
    loading : false,
    finished : false,
    textSearch: textSearch,

    formataResumo: function(descricao){
      return descricao.replace(/(<([^>]+)>)/gi, "").substr(0,300);
    },

    formataImg : function(img){
      return (img) ? `/api/v1/diminuator?file=socialmedia/images/${img}&w=500&h=625` : 'icon-conectassma-white.png';
    },

    analytics: function(){
      let loadingElements = document.getElementsByClassName('loading');
      if (typeof gtag === "function" && loadingElements.length > 0) {
          gtag('event', 'page_view', {
              'event_category': 'events',
              'event_label': 'Page ' + loadReels.page,
              'value': 1
          });
      }
    },

    load: function(){
      if(loadReels.finished) return;
      $(".loading").fadeIn();
      loadReels.loading = true;
      loadReels.page = loadReels.page + 1;
      $.ajax({
        dataType: "json",
        url: loadReels.textSearch == "" ? `/api/v1/reels/${loadReels.page}/` : `/api/v1/reels/${loadReels.textSearch}/${loadReels.page}/`,
        success: function(req){
          if (req[1].reels.length == 0) {
            loadReels.finished = true;
          } else {
            //advertising
            let ad = req[0].advertising[0];
            let ad_template = `<div class="cell large-12 ultra-banner">
                              <div class="desktop"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_desktop}" /></a></div>
                              <div class="mobile"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_mobile}" /></a></div>
                              </div>`;
            $(".lista-reels").append(ad_template);
            $.get(`/api/advertising-views/${ad.id}/`)
            //photogallery
            $(req[1].reels).each(function(ix, x){
              let template = `
                <div class="cell large-3 medium-6 small-12">
                  <div class="reel">
                    <div class="icon ${x.account}"></div>
                    <div class="nome"><a href="/redirect/instagram/?url=${x.url}" target="_blank">@${x.owner_username}</a></div>
                    <div class="foto">
                      <a href="/redirect/instagram/?url=${x.url}" target="_blank">
                        <img src="${loadReels.formataImg(x.image_local)}">
                      </a>
                    </div>
                    <div class="caption">
                      <span class="text">${x.caption || ''}</span>
                      <span class="dots">[...]</span>
                      <a href="/redirect/instagram/?url=${x.url}" target="_blank" class="more">ver post</a>
                    </div>
                  </div>
                </div>
              `
            $(".lista-reels").append(template);
            })
          }
          $(".loading").fadeOut();
          loadReels.analytics();
          loadReels.loading = false;
        }
      });
    },

    search: function(div){
        var search = $(`.search-form.${div} #searchText`).val().toString();
        if(!search){
            document.location.href = `/reels/`;
        } else {
            document.location.href = `/reels/${search}/`;
        }
    }
  };

  $(".search-form.desktop .icon").click(function(){
    $(".search-form .form").animate({width:'toggle'},350);
    $("#searchText").focus();
  });

  $(".search-form.desktop #btnOk").click(function(){ loadReels.search('desktop'); });
  $(".search-form.mobile #btnOk").click(function(){ loadReels.search('mobile'); });

  $(".search-form.desktop #searchText").on('keypress',function(e) {
    if(e.which == 13) $(".search-form.desktop #btnOk").click()
  });


  if(textSearch){
    $(".search-form.desktop #searchText,.search-form.mobile #searchText").val(textSearch)
    $(".search-form").addClass("search")
  }

  window.onscroll = function(ev) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 100) {
      if (loadReels.loading === false) {
        loadReels.load();
      }
      $('#back-to-top').addClass('visible');
    } else {
      if (scrollTop != 0) {
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
      }
    }

  };

});

$("#back-to-top").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow", function() {
    $('#back-to-top').removeClass('visible');
  });
});
